import * as React from 'react'

import { Text } from '../texts'
import { Styled } from './styled'

export const LinkComponent = (props) => {
  const {
    id,
    Icon,
    rightIcon,
    text,
    size,
    mood,
    width,
    link,
    onClick,
    fontSize,
  } = props;
  const Container = link ? Styled.AContainer : Styled.DivContainer
  const fontSizeToRender = fontSize
    ? fontSize
    : size === 's'
      ? 12
      : size === 'l'
        ? 18
        : 16
  return (
    <Container
      id={id}
      size={size}
      mood={mood}
      width={width}
      rightIcon={rightIcon}
      text={text}
      href={link}
      // eslint-disable-next-line react/jsx-no-bind
      onClick={e => onClick && onClick(e)}
    >
      {Icon && !rightIcon && <Icon />}
      {text && (
        <Text fontSize={fontSizeToRender}>
          {text}
        </Text>
      )}
      {Icon && rightIcon && <Icon />}
    </Container>
  )
}
